var map = {
	"./sfx_amb_fades_01.mp3": 341,
	"./sfx_amb_fades_02.mp3": 342,
	"./sfx_amb_fades_03.mp3": 343,
	"./sfx_amb_fades_04.mp3": 344,
	"./sfx_amb_fades_05.mp3": 345
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 340;